import { useMemo, useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { breakpoints } from '@ui/css';
import { safeLocalStorage } from '@utils/common';
import { useMatchBreakpoint } from '@utils/react';

const BASE_LOCAL_STORAGE_KEY = "opgavekomplekset:has-interacted-with-unoptimized-mobile-task";
const UNOPTIMIZED_TASK_TYPES_FOR_MOBILE = [{
  taskType: "PlaceItems",
  answerType: "SolidItemsOnImage"
}, {
  taskType: "PlaceItems",
  answerType: "TransparentImagesOnImage"
}, {
  taskType: "WriteAnswers",
  answerType: "OnImage"
}];
const hasInteractedSet = new Set();
function useWarnOnFirstMobileInteraction(component) {
  const notifier = useNotifier();
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const interactionKey = `${BASE_LOCAL_STORAGE_KEY}:${component.envelope.ID}`;
  const hasUnoptimizedTasksInComponent = useMemo(() => component.data.tasks.some(task => task.type === "stack" ? task.tasks.some(subTask => isUnoptimizedTask(subTask)) : isUnoptimizedTask(task)), [component.data.tasks]);
  return useCallback(async () => {
    const hasInteracted = hasInteractedSet.has(interactionKey) || safeLocalStorage.getItem(interactionKey) === "true";
    const enabled = hasUnoptimizedTasksInComponent && isMobile && !hasInteracted;
    if (!enabled) {
      return;
    }
    hasInteractedSet.add(interactionKey);
    await notifier.confirm({
      heading: "Overvej at løse opgaven på computer",
      body: "Der er opgaver i dette opgavesæt, der bliver meget små og dermed svære at løse på mobilen.",
      include: {
        ok: true,
        cancel: false
      },
      labels: {
        ok: "Ok, sådan er det"
      }
    });
    safeLocalStorage.setItem(interactionKey, "true");
  }, [hasUnoptimizedTasksInComponent, isMobile, interactionKey, notifier]);
}
function isUnoptimizedTask(task) {
  for (const unoptimizedTaskDefinition of UNOPTIMIZED_TASK_TYPES_FOR_MOBILE) {
    if (task.taskType === unoptimizedTaskDefinition.taskType && "answerType" in task && task.answerType === unoptimizedTaskDefinition.answerType) {
      return true;
    }
  }
  return false;
}

export { useWarnOnFirstMobileInteraction };
//# sourceMappingURL=hook.warn-on-mobile-interaction.js.map
